import { useHistory } from 'react-router-dom';
import { useTitle } from '../../hooks';

import { Typography, Box } from '@mui/material';

import Button from '../common/Button';

export default function FormSubmitted(props) {
  const history = useHistory();
  useTitle(props.documentTitle);

  const goToLogin = () => history.push('/login');

  return (
    <Box
      sx={{
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" sx={{ mx: 2, mt: 15, fontWeight: 600 }}>
        {props.title}
      </Typography>
      <Typography variant="h6" sx={{ mx: 1, mt: 10, fontWeight: 500 }}>
        {props.description}
      </Typography>
      <Button
        login
        fullWidth
        variant="outlined"
        size="large"
        onClick={goToLogin}
        sx={{ mt: 15 }}
      >
        {props.buttonText}
      </Button>
    </Box>
  );
}
